// The kinds of events Photohawk Studio is used for, each with a stock photo from src/content/media (Pexels License:
// src/content/media/CREDITS.md). Shown by src/components/EventTypesGrid.tsx on /studio, /for-organisers and
// /event-photography, and listed as those pages' images (src/lib/seo/pages.ts, src/lib/seo/eventPhotography.ts).
// Copy: home.studio.events.items.<id> (src/i18n/locales).
export const EVENT_TYPES = [
  { id: "running", image: "runner-finish-line-race-clock-stock" },
  { id: "cycling", image: "cycling-sportive-riders-street-stock" },
  { id: "triathlon", image: "triathlon-swim-start-sunrise-stock" },
  { id: "obstacle", image: "mud-run-obstacle-crawl-stock" },
  { id: "teamSport", image: "football-match-players-stock" },
  { id: "swimming", image: "swimming-race-dive-start-stock" },
  { id: "school", image: "graduation-caps-in-the-air-stock" },
  { id: "dance", image: "ballroom-dance-competition-stock" },
  { id: "motorsport", image: "motocross-race-riders-stock" },
  { id: "equestrian", image: "show-jumping-horse-rider-stock" },
  { id: "festivals", image: "music-festival-crowd-stock" },
  { id: "conferences", image: "conference-audience-stage-stock" },
] as const;

/** The grid's photos, as content image names. */
export const EVENT_TYPE_IMAGES: string[] = EVENT_TYPES.map((x) => x.image);
